/*
 * @Author: masonzhou
 * @Date: 2024-01-25 16:51:08
 * @LastEditTime: 2024-02-05 20:13:57
 * @FilePath: \yl-cjsph-tms-operation-front\src\utils\const.js
 * @Description:
 */
// 应用请求前缀
export const GATEWAY = {
  // CJS: 'cjsoperateweb',
  CJS: '/web/operate'
};

// 当地语言
export const LOCAL_LANG = {
  value: 'PH',
  label: '菲律宾语'
};

// 账户存储cookie命名
export const ACCOUNT_INFO_NAMES = {
  token: 'operation-token',
  username: 'operation-username',
  account: 'operation-account',
  password: 'operation-password',
  rememberMe: 'operation-rememberMe'
};
